const PaymentMethod = {
  CreditCard: 'CreditCard',
  PaymentCode: 'PaymentCode'
};

export default PaymentMethod;
